import { all } from 'redux-saga/effects';

import administrationSaga from 'store/administration/administration.saga';
import dictionariesSaga from 'store/dictionaries/dictionaries.saga';
import authSaga from 'store/auth/auth.saga';
import distributionSaga from 'store/distribution/distribution.saga';
import recommendationsSaga from 'store/recommendations/recommendations.saga';
import infoScreensSaga from 'store/infoScreens/infoScreens.saga';
import settingsSaga from 'store/settings/settings.saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    dictionariesSaga(),
    administrationSaga(),
    distributionSaga(),
    recommendationsSaga(),
    infoScreensSaga(),
    settingsSaga(),
  ]);
}
